import LoginPic from "../assets/img/loginPic.svg";
import LoginPic2 from "../assets/img/loginPic2.png";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { Box, Card, TextField, Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import useCustomState from "../hooks/State";
import Call from "../service/API";
import { getUserInfo, setUserInfo } from "../utils/UserInfo";
import { SetUserInfo } from "../store/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ERROR_COLOR, BLUE_PRIMARY } from "../utils/const";

const useStyles = makeStyles((theme) => ({
  input: {
    "&::placeholder": {
      color: "red",
      textAlign: "right",
    },
  },
}));

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const username = useCustomState("");
  const password = useCustomState("");

  const usernameError = useCustomState({ error: false, text: "" });
  const passwordError = useCustomState({ error: false, text: "" });
  const authenticationError = useCustomState(false);

  const usernameChanged = (e) => {
    authenticationError.handleChange(false);
    usernameError.handleChange({ error: false, text: "" });
    username.handleChange(e.target.value);
  };

  const passwordChanged = (e) => {
    authenticationError.handleChange(false);
    passwordError.handleChange({ error: false, text: "" });
    password.handleChange(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    if (username.value.length == 0) {
      usernameError.handleChange({
        error: true,
        text: "واردکردن نام کاربری الزامی است.",
      });
      hasError = true;
    }
    if (password.value.length == 0) {
      passwordError.handleChange({
        error: true,
        text: "واردکردن رمز عبور الزامی است.",
      });
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const data = {
      admin_phone: username.value,
      admin_password: password.value,
    };
    Call("POST", "admins/admin/login", data)
      .then((response) => {
        if (response.data.code == 200) {
          const data = response.data.data;
          setUserInfo(data);
          dispatch(SetUserInfo(data));
          history.push("/admin");
        } else {
          password.handleChange("");
          usernameError.handleChange({ error: true, text: "" });
          passwordError.handleChange({ error: true, text: "" });
          authenticationError.handleChange(true);
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          if (data.code === 403) {
            password.handleChange("");
            usernameError.handleChange({ error: true, text: "" });
            passwordError.handleChange({ error: true, text: "" });
            authenticationError.handleChange(true);
          }
        }
      });
  };

  return (
    <>
      {/* <div id={"picture-posotion"}>
       
      </div> */}
      <div
        style={{
          height: window.innerHeight,
          backgroundColor: "#fff",
          // border: "1px solid red",
        }}
      >
        <Container
          style={{
            paddingLeft: "5%",
            paddingRight: "5%",
            paddingTop: "80px",
          }}
          maxWidth="lg"
        >
          <Grid container spacing={1}>
            <Grid
              item
              style={{
                paddingRight: "5%",
                paddingLeft: "5%",
                marginBottom: "48px",
                // border: "1px solid red",
              }}
              xs={12}
              sm={12}
              md={6}
            >
              <img style={{ width: "100%" }} src={LoginPic2} />
            </Grid>
            <Grid
              style={{
                paddingRight: "2%",
                paddingLeft: "2%",
                // border: "1px solid red",
                paddingTop: "64px",
              }}
              item
              xs={12}
              sm={12}
              md={6}
            >
              <Card
                style={{
                  paddingRight: "5%",
                  paddingLeft: "5%",
                  paddingTop: "24px",
                  paddingBottom: "24px",
                  borderRadius: "12px",
                  overflow: "visible",
                }}
              >
                <Box
                  fullWidth
                  style={{
                    height: "64px",
                    backgroundColor: BLUE_PRIMARY,
                    borderRadius: "8px",
                    marginTop: "-48px",
                    paddingRight: "2%",
                    paddingLeft: "2%",
                    paddingTop: "16px",
                    paddingBottom: "16px",
                  }}
                >
                  <Typography
                    style={{ color: "#fff", fontWeight: "bold" }}
                    align="center"
                    variant="h5"
                  >
                    ورود به پنل مدیریت
                  </Typography>
                  <div style={{ marginTop: "8px" }}></div>
                  <Typography
                    style={{ color: "#fff", fontFamily: "Vazir" }}
                    align="center"
                    variant="body1"
                  >
                    شرکت سیال سنجش
                  </Typography>
                </Box>
                <div style={{ marginTop: "64px" }}></div>
                <form onSubmit={handleSubmit}>
                  <TextField
                    error={usernameError.value.error}
                    helperText={usernameError.value.text}
                    onChange={usernameChanged}
                    value={username.value}
                    fullWidth
                    variant="standard"
                    label="نام کاربری"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                  <div style={{ marginTop: "24px" }}></div>
                  <TextField
                    error={passwordError.value.error}
                    helperText={passwordError.value.text}
                    onChange={passwordChanged}
                    value={password.value}
                    fullWidth
                    variant="standard"
                    type={"password"}
                    label="کلمه عبور"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                  <div style={{ marginTop: "24px", width: "100%" }}></div>
                  <Typography
                    style={{
                      color: "#f44336",
                      fontFamily: "Vazir",
                      fontSize: "0.75rem",
                      display: authenticationError.value ? "" : "none",
                    }}
                    align="left"
                    variant="body1"
                  >
                    نام کاربری یا رمز عبور صحیح نیست.
                  </Typography>
                  <div style={{ marginTop: "24px", width: "100%" }}></div>
                  <Button
                    type="submit"
                    onClick={handleSubmit}
                    fullWidth
                    style={{ backgroundColor: BLUE_PRIMARY, color: "#fff" }}
                    variant="contained"
                    size="large"
                  >
                    ورود
                  </Button>
                </form>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
};

export default Login;
